import { LayoutService } from '../../layout.service';
import { Field } from '../../field';
import { Component, OnInit } from '@angular/core';
import * as g from './../../../globals';
import { NzImage, NzImageService } from 'ng-zorro-antd/image';

@Component({
  selector: 'app-input-image',
  templateUrl: './input-image.component.html',
  styleUrls: ['./input-image.component.scss'],
})
export class InputImageComponent extends Field {
  baseUrl = g.baseUrl;
  urlSuffix = g.getUrlSuffix();
  isMultiple = false;
  values = [];
  activeIndex = 0;

  constructor(
    public layoutService: LayoutService,
    private nzImageService: NzImageService
  ) {
    super(layoutService);
  }

  ngOnInit() {
    super.ngOnInit();

    const value = this.recordProperty.ValueAsObject as string;
    if (value != null && value.indexOf(';') != -1) {
      this.isMultiple = true;
      this.values = (this.recordProperty.ValueAsObject as string).split(';');
    }
  }

  previewImage(image) {
    let activeIndex = 0;
    let file = '';
    let images = [];
    let isVisible = false;

    if (image.indexOf(';') != -1) {
      file = '';
      images = image.split(';');
      let _images = images.map((image: string) => {
        if (image != null && image !== undefined && image.trim() !== '') {
          const img: NzImage = {
            src: image.startsWith('http') ? image : `${
              g.apiBaseUrl
            }media/PreviewFile?path=${image}&${g.getUrlSuffix()}`,
            width: '50vw',
            height: 'auto',
            alt: 'ng-zorro',
          };
          return img;
        }
      });
      _images = _images.filter((image) => image != null);
      this.nzImageService.preview(_images, { nzZoom: 1.5, nzRotate: 0 });
    } else {
      images = [];
      file = image;
      isVisible = true;
      const _images = [
        {
          src: image.startsWith('http') ? image : `${
            g.apiBaseUrl
          }media/PreviewFile?path=${image}&${g.getUrlSuffix()}`,
          width: '50vw',
          height: 'auto',
          alt: 'ng-zorro',
        },
      ];
      this.nzImageService.preview(_images, { nzZoom: 1.5, nzRotate: 0 });
    }
  }
}
